import { useQuery } from '@tanstack/react-query'
import { useParams } from '@tanstack/react-router'
import { useAtomValue } from 'jotai'

import { useAuth } from '@/features/auth/hooks/'
import { getSiteDisplaySettingOptions } from '@/features/dcs/query-options'
import { getInHouseQueryOptions } from '@/features/partners/query-options'
import { USER_TYPE } from '@/libs/api/types'
import { selectedDcIdAtom } from '@/routes/_protected/$tenantKey/-states'

/**
 * 選択中拠点の自社パートナー情報から useSiteMiddleName を取得するフック
 * @returns useSiteMiddleName の値（取得失敗時は false）
 *
 * パートナーユーザーは自社情報（拠点の自社パートナー）を読めないので、この 1 項目だけを返す
 * 拠点の表示設定 API から読む（#5600）。拠点ユーザーは自社情報から読む（編集画面の保存時の
 * キャッシュ無効化がこのクエリに掛かっているため、経路を変えない）
 */
export const useSiteMiddleName = () => {
  const { tenantKey } = useParams({ strict: false })
  const selectedDcId = useAtomValue(selectedDcIdAtom)
  const { user } = useAuth()
  const isPartner = user?.type === USER_TYPE.PARTNER
  const hasTarget = !!tenantKey && !!selectedDcId

  const { data: inHouse } = useQuery({
    ...getInHouseQueryOptions({
      tenantKey: tenantKey!,
      dcId: selectedDcId!
    }),
    enabled: hasTarget && !isPartner
  })
  const { data: siteDisplaySetting } = useQuery({
    ...getSiteDisplaySettingOptions(tenantKey!, selectedDcId!),
    enabled: hasTarget && isPartner
  })

  return (
    (isPartner
      ? siteDisplaySetting?.useSiteMiddleName
      : inHouse?.useSiteMiddleName) ?? false
  )
}
